import { ArtefactKind } from "@/services/backend/artefacts/kind";
import { useNumbersArtefactNumberShowQuery } from "@/services/backend/numbers/artefact-number/service";
import { RTKQueryErrorAlert } from "../errors/rtk-query-error-alert";

interface InspectionReportNumberProps {
  artefactId: string;
}

export function InspectionReportNumber({
  artefactId,
}: InspectionReportNumberProps) {
  const { data, error } = useNumbersArtefactNumberShowQuery({
    artefactId,
    artefactKind: ArtefactKind.Inspection,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (data != null) return <span className="">{data.string}</span>;

  return <span>Kein Probenset gefunden</span>;
}
